// What the board says when a link names an account the served book does not have.
//
// `/execution?account=<id>` comes from a Slack request card's "Open in dashboard", Scout's
// answers and the extension. The sidebar opens only for a row on the book, so a link to an
// account that is not on it (a company the door just created, a request still waiting, one that
// was declined) used to do nothing at all (Vikram's test pass, 7 Oct: Deqx). Now the board says
// why, using the request on file when there is one for its name.

import type { BookPayload } from '../api/types';

/** The account a link named but the book does not have, or null when it is there (or loading). */
export function missingLinkedAccountId(
  book: BookPayload | null | undefined,
  linkedAccountId: string | null,
): string | null {
  if (!book || !linkedAccountId) return null;
  const onBook = book.accounts.some(row => row.id === linkedAccountId);
  return onBook ? null : linkedAccountId;
}

/** The sentence for a linked account that is not on the book. */
export function missingAccountNotice(book: BookPayload, accountId: string): string {
  const request = book.bank_requests?.[accountId] ?? null;
  const name = request?.name || request?.domain || 'That account';
  if (request?.status === 'pending') {
    return `${name} isn't on the book yet: its request is waiting for approval. Its sidebar opens here once it's approved and the book refreshes.`;
  }
  if (request?.status === 'approved') {
    return `${name} was approved and shows here after the next book refresh.`;
  }
  if (request?.status === 'declined') {
    const reason = request.declined_reason ? ` (${request.declined_reason})` : '';
    return `${name} isn't on the book: its request was declined${reason}. Request it again to see it here.`;
  }
  return `${name} isn't on the book yet, so there's no sidebar to open. Request it to see it here.`;
}
